import { render, staticRenderFns } from "./ChatRedPacket.vue?vue&type=template&id=1c8f2d10&scoped=true"
import script from "./ChatRedPacket.vue?vue&type=script&lang=js"
export * from "./ChatRedPacket.vue?vue&type=script&lang=js"
import style0 from "./ChatRedPacket.vue?vue&type=style&index=0&id=1c8f2d10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f2d10",
  null
  
)

export default component.exports